module.exports = __webpack_public_path__ + "img/Vector.28e93e26.svg";